import { Collapsable } from "./Collapsable";

import "./SearchableList.css";
import { CommandLarge } from "./Commands/CommandLarge";

export type CommandCategory = {
    name: string;
    showInput: boolean;
    showPrice: boolean;
    enabled: boolean;
    commands: CommandData[];
};

export type CommandData = {
    title: string;
    desc: string;
    input: string | null;
    price: number | null;
};

interface Props {
    search?: string;
    category: CommandCategory;
}

export function SearchableList({ search, category }: Props) {
    const hideCommand = (cmd: CommandData) => {
        return (
            search &&
            !cmd.title?.toLowerCase().includes(search) &&
            !cmd.desc?.toLowerCase().includes(search) &&
            !cmd.input?.toLowerCase().includes(search)
        );
    };
    return (
        <Collapsable title={category.name} key={search}>
            <table className="searchable-list-table">
                <tbody>
                    <tr className="hide-on-mobile">
                        <th>Name</th>
                        <th className="expand">Description</th>
                        {category.showInput && (
                            <th className="expand">Input</th>
                        )}
                        {category.showPrice && <th>Price</th>}
                    </tr>
                    {category.commands.map((d) => {
                        const hide = hideCommand(d);

                        if (hide) return null;
                        return (
                            <CommandLarge
                                key={`id${d.price}${d.title}`}
                                {...d}
                                price={d.price}
                                input={d.input}
                            />
                        );
                    })}
                    {category.commands.filter((c) => !hideCommand(c)).length ===
                        0 && (
                        <CommandLarge
                            title="No commands found"
                            desc=""
                            input={null}
                            price={null}
                        />
                    )}
                </tbody>
            </table>
        </Collapsable>
    );
}
